"use strict";

import React from "react";
import _ from "lodash";
import Modal from "../base/Modal";

import LayoutChooser from "./LayoutChooser";

import connectToStores from "../providers/connectToStores";
import LayoutChooserStore from "../../stores/LayoutChooserStore";

class LayoutChooserModal extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    let modalProps = _.pick(this.props, Modal.BASIC_PROPS);
    let { layoutChooserData } = this.props;
    let { settings, preview } = layoutChooserData;

    return (
      <Modal {...modalProps} style={{ width: "100%", height: "100%" }}>
        <Modal.Dialog id="layout_chooser">
          <Modal.Dialog.Header closeButton>
            <Modal.Dialog.Title>Mobile Layout Assistance</Modal.Dialog.Title>
          </Modal.Dialog.Header>
          <Modal.Dialog.Body style={{ padding: 0, height: "100%" }}>
            <LayoutChooser settings={settings} preview={preview} />
          </Modal.Dialog.Body>
        </Modal.Dialog>
      </Modal>
    );
  }
}

export default connectToStores(LayoutChooserModal, [
  {
    store: LayoutChooserStore,
    state: { layoutChooserData: LayoutChooserStore.getState },
  },
]);
